import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faThumbsUp, faLink, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import '../auth_list/AuthList.css';

import { Redirect } from "react-router-dom";

import { DetailsCard } from "../_common";

type PoCardItem = {
    card: {
        id: number,
        refOne: string,
        staffNm: string,
        creditor: string,
        authAmmt: number,
        curr: string,
        trans_date: string,
        due: string,
        approved: string,
        synched: string,
        exo_link: string,
        file_name: string
    },
    selected_approve: boolean
}

export class PoCard extends React.Component<PoCardItem> {
    static defaultProps = {
        card: {
            id: -1,
            refOne: '',
            staffNm: '',
            creditor: '',
            authAmmt: -1,
            curr: '',
            trans_date: '',
            due: '',
            approved: '',
            synched: '',
            exo_link: '',
            file_name: 'dummy.pdf'
        },
        selected_approve: false
    }

    state = {
        drill: false,
        approved: (this.props.card.approved === 'Y'),
        approve_timer: '5',
        result: {
            Error: 200,
            Message: 'None',
            Package: false
        },
        hasErrors: false
    };

    render() {
        var { drill } = this.state;
        var { approved } = this.state;
        var activeButtons = { approve: true, exo: false, details: false, view_doc: true }; // Active Buttons

        if (drill) {
            return <Redirect to={{ pathname: './Approvals/POA/' + this.props.card.id }} />;
        } else {
            var { card } =  this.props;
            var button_settings = 'col-12 col-lg-3 btn btn-default border AuthCard float-right';

            var { selected_approve } = this.props;
            return (
                <>
                <div id={card.id.toString()}>
                    <div className="row">
                        <div className="col-9 col-lg-10">
                            <div className="row">
                                <div className="col col-6 col-lg-4">
                                    <DetailsCard details={{title: 'Staff Member:', data: card.staffNm, bpad: true}} />
                                </div>
                                <div className="col col-6 col-lg-8">
                                    <DetailsCard details={{title: 'Creditor:', data: card.creditor, bpad: true}} />
                                </div>

                                <div className="col col-12">
                                    <DetailsCard details={{title: 'Reference:', data: card.refOne, bpad: true}} />
                                </div>
                                
                                <div className="col col-4">
                                    <DetailsCard details={{title: 'Ord Date:', data: card.trans_date, bpad: false}} />
                                </div>
                                <div className="col col-4">
                                    <DetailsCard details={{title: 'Due Date:', data: card.due, bpad: true}} />
                                </div>
                                <div className="col col-4">
                                    <DetailsCard details={{title: 'Amount:', data: card.authAmmt.toFixed(2) + ' (' + card.curr + ')', bpad: false}} />
                                </div>
                            </div>
                        </div>

                        <div className="d-block d-lg-none col-3">
                            {activeButtons.view_doc && this.props.card.file_name !== '' &&
                            <button className={button_settings} onClick={this.viewFile}>
                                <FontAwesomeIcon className="text-info" icon={faFilePdf} size="lg" fixedWidth /><br />
                                <div className="sub_txt">View File</div>
                            </button>
                            }
                            {activeButtons.details &&
                            <button className={button_settings} onClick={this.details}>
                                <FontAwesomeIcon className="text-info" icon={faClipboardList} size="lg" fixedWidth /><br />
                                <div className="sub_txt">Details</div>
                            </button>
                            }
                            {activeButtons.exo &&
                            <a className={button_settings} href={card.exo_link}>
                                <FontAwesomeIcon className="text-info" icon={faLink} size="lg" fixedWidth /><br />
                                <div className="sub_txt">Exo</div>
                            </a>
                            }
                            {activeButtons.approve &&
                            <button className={button_settings} onClick={this.approve}>
                                <FontAwesomeIcon className={selected_approve ? 'text-success' : approved ?  'text-warning' : 'text-info'} icon={faThumbsUp} size="lg" fixedWidth /><br />
                                <div className="sub_txt">{approved ? 'Approved' : 'Approve'}</div>
                            </button>
                            }
                        </div>

                        <div className="d-none d-lg-block col-2 text-right">
                            {activeButtons.approve &&
                            <button className={button_settings} onClick={this.approve}>
                                <FontAwesomeIcon className={selected_approve ? 'text-success' : approved ?  'text-warning' : 'text-info'} icon={faThumbsUp} size="lg" fixedWidth /><br />
                                <div className="sub_txt">{approved ? 'Approved' : 'Approve'}</div>
                            </button>
                            }
                            {activeButtons.exo &&
                            <a className={button_settings} href={card.exo_link}>
                                <FontAwesomeIcon className="text-info" icon={faLink} size="lg" fixedWidth /><br />
                                <div className="sub_txt">Exo</div>
                            </a>
                            }
                            {activeButtons.details &&
                            <button className={button_settings} onClick={this.details}>
                                <FontAwesomeIcon className="text-info" icon={faClipboardList} size="lg" fixedWidth /><br />
                                <div className="sub_txt">Details</div>
                            </button>
                            }
                            {activeButtons.view_doc && this.props.card.file_name !== '' &&
                            <button className={button_settings} onClick={this.viewFile}>
                                <FontAwesomeIcon className="text-info" icon={faFilePdf} size="lg" fixedWidth /><br />
                                <div className="sub_txt">View File</div>
                            </button>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 text-danger">
                            {this.state.hasErrors && <small>Errors</small>}
                        </div>
                    </div>
                </div>
                </>
            )
        }
    }

    private authenticated = () => {
        return (sessionStorage.getItem('session') !== null) ? (sessionStorage.session.length > 10) : false;
    }

    private details = () => {
        if (this.authenticated()) {
            this.setState({ drill: true });
        }
    }

    private viewFile = () => {
        var fileName = this.props.card.file_name;
        //var filePath = `${process.env.PUBLIC_URL}/uploadedFiles/`+fileName; // Removed to allow for any location FTP 20200321
        var filePath = 'https://optimiseyourbusiness.co.nz/Approvals/ApprovalSystem/uploadedFiles/'+fileName;
        window.open(filePath, "_blank");
    }

    private hold = () => {
        if (this.authenticated()) {
            /*
            var tmp_url = "https://optimiseyourbusiness.co.nz/Approvals/ApprovalSystem/POA/Hold";
            var payload = {
                Session: sessionStorage.getItem('session'),
                TransList: [{ Id: this.props.card.id }],
                Type: (this.state.onhold) ? "remove-hold" : "hold"
            }
            
            fetch(tmp_url, {
                method: "POST",
                body: JSON.stringify(payload)
            })
            .then(res => res.json())
            .then(res => {
                this.setState({ result: res });
            })
            .then(() => {
                this.setState({ onhold: this.state.result.Package!==false });
            })
            .catch(() => this.setState({ hasErrors: true }));
            */
        }
    }

    private approve = () => {
        if (this.authenticated()) {
            var tmp_url = "https://optimiseyourbusiness.co.nz/Approvals/ApprovalSystem/POA/Auth";
            var payload = {
                Session: sessionStorage.getItem('session'),
                TransList: [{ Id: this.props.card.id }],
                Type: (this.state.approved) ? "de-auth" : "auth"
            }

            fetch(tmp_url, {
                method: "POST",
                body: JSON.stringify(payload)
            })
            .then(res => res.json())
            .then(res => {
                this.setState({ result: res });
            })
            .then(() => {
                this.setState({ approved: this.state.result.Package!==false });
            })
            .catch(() => this.setState({ hasErrors: true }));
        }
    }
}

export default PoCard;